import type { ToastProps } from '@nuxt/ui'
// @ts-ignore
import { useToast } from '#imports'

export default (opts: ToastProps) => {
	const toast = useToast()
	toast.add(opts)
}
